module.exports = __webpack_public_path__ + "media/fr_ca_s4_Symone.3cbaf831.mp3";